var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"parallax",style:(_vm.style)},[(_vm.type === 'fixed' && !_vm.ios)?_c('div',{style:(_vm.fixedParentStyle)},[_c('div',{staticClass:"image",style:(_vm.fixedChildStyle)})]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }